import styled from 'styled-components';

export const OrganizationSwitcher = styled.div`
  padding: 8px 0;
  margin-left: 8px;
`;

export const CurrentOrganizationWraper = styled.div`
  color: rgba(0, 0, 0, 0.45);
`;

export const CurrentItemWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;

  .anticon-down-square {
    margin-top: 1px;
  }

  &:hover {
    color: rgba(24, 144, 255, 1);
    span {
      color: rgba(24, 144, 255, 1);
    }
  }
`;

export const OrganizationName = styled.span`
  margin-left: 5px;
  color: inherit;
`;

export const InactiveSelectorItem = styled.span`
  color: #1890ff;
  transition: all 0.3s;
`;

export const ActiveSelectorItem = styled.button.attrs({
  type: 'button',
})`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  cursor: pointer;
  display: inline;
  outline: none;
  width: 100%;
  text-align: left;

  &:focus {
    outline: none;
  }
`;

export const DropdownScrollableMenu = styled.div`
  max-height: 300px;
  overflow-y: auto;
  box-shadow:
    0px 3px 6px -4px rgba(0, 0, 0, 0.12),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    0px 9px 28px 8px rgba(0, 0, 0, 0.08);
  margin-top: 8px;
  color: rgba(0, 0, 0, 0.85);
`;
